import { useState, useEffect } from 'react';

import { TRIVAGO_KEY } from '@constants/constants';

function getTrvReferenceFromUrl(url: string): string | null {
  const urlParams = new URLSearchParams(url);
  return urlParams.get('trv_reference');
}

const useCatchTrivagoUser = (asPath: string) => {
  const [affiliation, setAffiliation] = useState(null);

  useEffect(() => {
    const currentTime = new Date();
    const item = {
      value: TRIVAGO_KEY,
      trv_refrence: getTrvReferenceFromUrl(asPath),
      expiresAt: currentTime.getTime() + 300000 * 12, // Expires in 1 hour
    };

    if (asPath.includes(TRIVAGO_KEY)) {
      localStorage.setItem(TRIVAGO_KEY, JSON.stringify(item));
      setAffiliation(item);
    } else {
      const checkTime = JSON.parse(localStorage.getItem(TRIVAGO_KEY));
      if (checkTime && checkTime?.expiresAt < currentTime.getTime()) {
        localStorage.removeItem(TRIVAGO_KEY);
      } else {
        setAffiliation(checkTime);
        setTimeout(() => {
          localStorage.removeItem(TRIVAGO_KEY);
          setAffiliation(null);
        }, checkTime?.expiresAt - currentTime.getTime());
      }
    }
  }, [asPath]);

  return affiliation;
};

export default useCatchTrivagoUser;
